import { Http } from '@utils';
import { AppBandwidthTypes } from '@types';

export interface UpdateArgs {
  bandwidth?: AppBandwidthTypes;
  clientId: string;
  filename: string;
  high: number;
  low: number;
}

export interface ImportSampleArgs {
  bandwidth?: AppBandwidthTypes;
  clientId: string;
  filename?: string;
  imageUrl: string;
}

export interface ImportStaticSampleArgs {
  bandwidth?: AppBandwidthTypes;
  clientId: string;
  imageId: string;
}

const ImageApi = {
  // Used for initial upload and then all future updates.
  update({
    bandwidth = 'LOW',
    clientId,
    filename,
    high,
    low,
  }:UpdateArgs) {
    return Http.post(`/update/${clientId}`, {
      bandwidth,
      filename,
      high,
      low,
    });
  },

  // Initial import from 3rd party (was using Unsplash.)
  importSample({
    clientId,
    bandwidth = 'LOW',
    imageUrl,
    filename = 'img.jpg',
  }: ImportSampleArgs) {
    return Http.post(`/import/${clientId}`, {
      bandwidth,
      image_url: imageUrl,
      filename,
    });
  },

  importStaticSample({
    clientId,
    bandwidth = 'LOW',
    imageId,
  }: ImportStaticSampleArgs) {
    return Http.post(`/copy/${clientId}`, {
      bandwidth,
      image_id: imageId,
    });
  },

  getSamples() {
    return Http.post('/samples');
  },
};

export default ImageApi;
